const en_whs_returncus = {
    "": "return pelanggan",
    detail: "customer return detail",
}

export default en_whs_returncus;